export const Theme = {
	scrollBar: 'rgba(255, 255, 255, 1)',
	scrollThumb: 'rgba(13, 75, 191, 1)',
	container: 'rgba(245, 246, 246, 1)',
	primary: 'rgba(25, 172, 113, 1)',
	secondary: 'rgba(13, 75, 191, 1)',
	disabled: 'rgba(204, 204, 204, 1)',
	shadow: 'rgba(234, 234, 234, 1)',
	success: 'rgba(25, 172, 113, 1)',
	error: 'rgba(227, 57, 70, 1)',
	lightError: 'rgba(227, 57, 70, 0.05)',
	blue: 'rgba(13, 75, 191, 1)',
	lightBlue: 'rgba(13, 75, 191, 0.1)',
	green: 'rgba(25, 172, 113, 1)',
	red: 'rgba(227, 57, 70, 1)',
	lightRed: 'rgba(227, 57, 70, 0.10)',
	orange: 'rgba(255, 111, 0, 1)',
	yellow: 'rgba(255, 209, 26, 1)',
	black: 'rgba(0, 0, 0, 1)',
	lightBlack: 'rgba(0, 0, 0, 0.75)',
	white: 'rgba(255, 255, 255, 1)',
	lightWhite: 'rgba(252, 252, 252, 1)',
	creamWhite: 'rgba(245, 246, 246, 1)',
	lightGrey: 'rgba(234, 234, 234, 1)',
	mediumGrey: 'rgba(192, 192, 192, 1)',
	darkGrey: 'rgba(102, 102, 102, 1)',
	transparent: 'rgba(255, 255, 255, 1)',
	backdrop: 'rgba(255, 255, 255, 0.5)',
};
